<template>
  <div class="form-content-wrapper">
    <h6 class="form-title mb-1">DATA KELUARGA</h6>
    <div class="text-muted smallText mb-3">
      * Hanya wajib diisi BILA anggota ingin menggadaikan BPKB<br />
      Bila tidak ada keluarga / keluarga tidak memiliki nomor handphone aktif, mohon diisi dengan nomor handphone nasabah.
    </div>

    <b-row>
      <b-col lg="4" md="6">
        <b-form-group label="Suami/Istri">
          <b-form-input v-model="dataKerabat.namaSuamiAtauIstri" name="dataKerabatNamapasangan"/>
        </b-form-group>
      </b-col>

      <b-col lg="4" md="6">
        <b-form-group>
          <label for="dataKerabatNamaAyah">
            Ayah
            <!-- <span v-if="!vDataKerabat.namaAyah.required && vDataKerabat.namaAyah.$dirty" class="text-danger">Kolom tidak boleh kosong</span> -->
          </label>
          <b-form-input v-model="dataKerabat.namaAyah" name="dataKerabatNamaAyah" placeholder="Ketik Nama Orangtua"/>
        </b-form-group>
      </b-col>

      <b-col lg="4" md="6">
        <b-form-group>
          <label for="dataKerabatNamaIbu">
            Ibu
            <!-- <span v-if="!vDataKerabat.namaIbu.required && vDataKerabat.namaIbu.$dirty" class="text-danger">Kolom tidak boleh kosong</span> -->
          </label>
          <b-form-input v-model="dataKerabat.namaIbu" name="dataKerabatNamaIbu" placeholder="Ketik Nama Orangtua"/>
        </b-form-group>
      </b-col>

      <!-- PHONE: Suami/Istri (tidak wajib tapi harus match regex jika diisi) -->
      <b-col lg="4" md="6">
        <b-form-group label="No. Handphone Suami / Istri">
          <b-form-input
            v-model="dataKerabat.noHandphoneSuamiIstri"
            inputmode="tel"
            maxlength="13"
            placeholder="08xxxxxxxxxx"
            @keypress="numberOnly"
            @input="onPhoneInput('noHandphoneSuamiIstri', $event)"
            @blur="onPhoneBlur('noHandphoneSuamiIstri'); vDataKerabat.noHandphoneSuamiIstri.$touch()"
          />
          <span style="font-size: xx-small;">
            Nomor harus mulai dengan 08 dan total 10–13 digit.
          </span>
        </b-form-group>
      </b-col>

      <!-- PHONE: Ayah (wajib + regex) -->
      <b-col lg="4" md="6">
        <b-form-group>
          <label for="noHandphoneAyah">
            No. Handphone Ayah
            <!-- <span v-if="!vDataKerabat.noHandphoneAyah.required && vDataKerabat.noHandphoneAyah.$dirty" class="text-danger">Kolom tidak boleh kosong</span> -->
          </label>
          <b-form-input
            v-model="dataKerabat.noHandphoneAyah"
            name="noHandphoneAyah"
            inputmode="tel"
            maxlength="13"
            placeholder="Ketik Nomor Telepon"
            @keypress="numberOnly"
            @input="onPhoneInput('noHandphoneAyah', $event)"
            @blur="onPhoneBlur('noHandphoneAyah'); vDataKerabat.noHandphoneAyah.$touch()"
          />
          <span style="font-size: xx-small;">
            Nomor harus mulai dengan 08 dan total 10–13 digit.
          </span>
        </b-form-group>
      </b-col>

      <!-- PHONE: Ibu (wajib + regex) -->
      <b-col lg="4" md="6">
        <b-form-group>
          <label for="noHandphoneIbu">
            No. Handphone Ibu
            <!-- <span v-if="!vDataKerabat.noHandphoneIbu.required && vDataKerabat.noHandphoneIbu.$dirty" class="text-danger">Kolom tidak boleh kosong</span> -->
          </label>
          <b-form-input
            v-model="dataKerabat.noHandphoneIbu"
            name="noHandphoneIbu"
            inputmode="tel"
            maxlength="13"
            placeholder="Ketik Nomor Telepon"
            @keypress="numberOnly"
            @input="onPhoneInput('noHandphoneIbu', $event)"
            @blur="onPhoneBlur('noHandphoneIbu'); vDataKerabat.noHandphoneIbu.$touch()"
          />
          <span style="font-size: xx-small;">
            Nomor harus mulai dengan 08 dan total 10–13 digit.
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="form-wrapper-btn submit-btn-wrapper">
          <b-button name="identitasResetBtn" variant="danger" @click="$emit('reset')">Reset Kerabat</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";

export default {
  mixins: [validationMixin],
  name: "data-kerabat",
  props: {
    dataKerabat: { type: Object, required: false },
    // kirimkan dari parent: :vDataKerabat="$v.dataKerabat"
    vDataKerabat: { type: Object, required: false },
  },
  methods: {
    numberOnly(e) {
      const code = e.which || e.keyCode;
      if ([8,9,13,37,38,39,40].includes(code)) return; // allow ctrl keys
      const ch = String.fromCharCode(code);
      if (!/[0-9]/.test(ch)) e.preventDefault();
    },
    onPhoneInput(field, e) {
      const digits = (e.target.value || "").replace(/\D/g, "").slice(0, 13);
      this.$set(this.dataKerabat, field, digits);
    },
    onPhoneBlur(field) {
      // OPSIONAL: normalisasi 62/+62 → 0
      let raw = (this.dataKerabat[field] || "").replace(/\D/g, "");
      if (raw.startsWith("62")) raw = "0" + raw.slice(2);
      this.$set(this.dataKerabat, field, raw.slice(0, 13));
    },
    fieldState(vField) {
      // null = belum disentuh (tidak show merah/hijau), true/false = valid/invalid
      if (!vField) return null;
      return vField.$dirty ? !vField.$invalid : null;
    },
  },
};
</script>
